import { Injectable } from "@angular/core"
import { AngularFirestore, AngularFirestoreCollection, QueryDocumentSnapshot, QuerySnapshot } from "@angular/fire/firestore"
import { User } from "@tr/models"
import { getData } from "@tr/utils"

@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor(
    private afs: AngularFirestore,
  ) { }

  public async getSevaKPIRef(): Promise<QueryDocumentSnapshot<any>> {
    return await this.afs
      .collection("globalVariables")
      .doc("sevaKPIs")
      .ref.get()
  }

  public async getSevaTester(): Promise<QuerySnapshot<any>> {
    return await this.getSevaTestersCollection()
      .ref.get()
  }

  public getSevaTesterResultsCollection(uid: string): AngularFirestoreCollection {
    return this.getSevaTestersCollection()
      .doc(uid)
      .collection("Results")
  }
  public async getSevaTesterResults(uid: string): Promise<any> {
    const sevaTesterResults = await this.getSevaTesterResultsCollection(uid)
      .ref.get()
    return getData<any>(sevaTesterResults)
  }

  // Incomplete test of first list in Firebase
  public async getIncompleteTests(): Promise<QuerySnapshot<any>> {
    return await this.afs
      .collection("IncompleteTests")
      .ref.get()
  }
  public getSevaTeamUsers(): AngularFirestoreCollection {
    return this.afs
      .collection("companies")
      .doc("Seva Team")
      .collection("users")
  }

  public getSevaTestersCollection(): AngularFirestoreCollection {
    return this.afs
      .collection("Seva Testers")
  }
  public getUsers(): AngularFirestoreCollection {
    return this.afs
      .collection("users")
  }
  public async getUserByID(uid: string): Promise<User> {
    const userRef = await this.afs
      .collection("users")
      .doc(uid)
      .ref.get()

    return {
      ...userRef.data() as User,
      _id: userRef.id,
    }
  }
}
